import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    .iframe{
    min-height: 500px;
    height: auto;
    border: none;
  }
  .report-style-class {
    height: 600px;
    width: 100%;
  }
  .App {
    text-align: center;
  }
  
    margin-bottom: 50px;
    @media (min-width: ${theme.breakpoints.tablet}px) {
      
    }
    @media (min-width: ${theme.breakpoints.desktop}px) {
      
    }
  `}
`;